var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 0.333313C12.7799 0.333313 0.833252 12.28 0.833252 27C0.833252 41.72 12.7799 53.6666 27.4999 53.6666C42.2199 53.6666 54.1666 41.72 54.1666 27C54.1666 12.28 42.2199 0.333313 27.4999 0.333313ZM22.1666 39V15L38.1666 27L22.1666 39Z",
    fill: "#594AE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayCircle);
export default __webpack_public_path__ + "static/media/icon-play-circle.b6958dce1063e44f7671b72cfc775be0.svg";
export { ForwardRef as ReactComponent };